'use client';

import ArrowRight from '@/assets/svg/ArrowRight';
import Behance from '@/assets/svg/behance';
import Facebook from '@/assets/svg/facebook';
import Logo from '@/assets/svg/EdocaiLogo';
import In from '@/assets/svg/in';
import Inst from '@/assets/svg/inst';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils';
import OphirStd from '@/components/layout/OphirStd';
import Image from 'next/image';

import LogoFooter from "../../../assets/edocai/edocai_footer.png"

interface FooterProps {
  text: any;
  lang: string;
}

const services = [
  {
    label: 'Ophir Fundamentals',
    href: '/services#ophir-fundamentals',
  },
  {
    label: 'Ophir Industrial',
    href: '/services#ophir-industrial',
  },
  {
    label: 'Ophir Entertainment',
    href: '/services#ophir-entertainment',
  },
  {
    label: 'O-FAM Virtual Production',
    href: '/services#o-fam-virtual-production',
  },
];

export default function Footer(props: FooterProps) {
  const { text: dict, lang: lang } = props;

  const pathname = usePathname();
  let contacts = true;
  if (pathname.split('/').includes('contact')) contacts = false;

  return (
    <footer className='bg-[#101011] text-[#F2F2F2] flex flex-col items-center rounded-t-[40px] -mt-[40px] relative z-10 '>
      <div className='pt-14 w-full max-w-[1920px] lg:pt-12 lg:px-20 sm:pt-12 md:pt-16 px-28 md:px-8 sm:px-14 2xl:pr-[160px] pl-[90px] pr-[90px] sm:pr-[40px] sm:pl-[40px]'>
        <div className='rounded-t-[80px]'>
          <div className='flex justify-between 2xl:pb-16 pb-12 sm:pb-10 flex-col gap-8'>
            <div className='sm:tracking-normal sm:leading-none tracking-[-0.05em] sm:gap-2 flex flex-col gap-4 leading-none font-light'>
              <div className='text-left 2xl:text-[30px] text-[20px] sm:text-[15px] font-normal'>
                <div
                  dangerouslySetInnerHTML={{ __html: lang == 'it' ? 'Pronto a dare vita al tuo progetto?' : 'Got a project in mind?<br />Let’s bring your vision to life together.' }}
                >

                </div>
              </div>
              <Link href={lang == 'it' ? '/it/contattaci' : '/en/contacts'} className='inline-block w-fit'>
                <div className='flex gap-4 items-center w-fit'>
                  <div className='hover:underline w-fit 2xl:text-[72px] text-[48px] font-normal sm:text-[38px] leading-none tracking-[-0.05em]'>
                    {lang == 'it' ? 'Contattaci' : 'Contact Us'}
                  </div>
                  <div className='2xl:w-[49px] 2xl:h-[40px] w-[32px] h-[26px] sm:w-[26px] sm:h-[21.25px]'>
                    <ArrowRight />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className='flex flex-col 2xl:gap-32 gap-16 sm:gap-10 lg:gap-8 pb-16 sm:pb-2'>
          <div className='text-[18px] md:text-[20px]'>
            <div className='w-full flex justify-end md:justify-start sm:justify-start'>
              <div className='flex w-[60%] sm:w-full lg:w-full md:w-full justify-between sm:gap-10 md:gap-12 sm:flex-col'>
                <div>
                  {/* <h3 className='font-bold uppercase sm:text-lg 2xl:text-[24px] text-[16px] tracking-[-0.04] sm:text-[18.48px] leading-[120%]'>
                    {dict.services}
                  </h3>
                  <ul className='space-y-1 my-3'>
                    {services.map((service, index) => (
                      <li
                        className='sm:text-base 2xl:text-[20px] text-[13px] sm:text-[15.4px] tracking-[-0.03] font-normal leading-[120%]'
                        key={index}
                      >
                        <Link href={service.href}>{service.label}</Link>
                      </li>
                    ))}
                  </ul> */}
                </div>
                <div className='flex flex-col gap-2 sm:text-lg'>
                  <Link href='https://www.ophirstudio.com/' target='_blank'>
                    <h3 className='font-bold 2xl:text-[24px] text-[16px] tracking-[-0.04] leading-[120%] sm:text-[18.48px] uppercase'>
                      {dict.studio}
                    </h3>
                  </Link>
                  {/* <Link href='/portfolio'>
                    <h3 className='font-bold 2xl:text-[24px] text-[16px] tracking-[-0.04] leading-[120%] sm:text-[18.48px] uppercase'>
                      {dict.projects}
                    </h3>
                  </Link>
                  <Link href='/join-the-team'>
                    <h3 className='font-bold 2xl:text-[24px] text-[16px] tracking-[-0.04] leading-[120%] sm:text-[18.48px] uppercase'>
                      {dict.join}
                    </h3>
                  </Link> */}
                </div>

                <div>
                  <h3 className='sm:text-lg hidden sm:block font-bold text-[24px] tracking-[-0.04] leading-[120%] sm:text-[18.48px] uppercase'>
                    Socials
                  </h3>
                  <div className='flex flex-col gap-2 sm:mt-2'>
                    <div className='flex items-center gap-2'>
                      <div className='h-6 w-6 sm:w-[18px] sm:h-[18px]'>
                        <Behance />
                      </div>
                      <a
                        href='https://www.behance.net/ophirstudio'
                        target='_blank'
                        className='font-normal 2xl:text-[20px] text-[13px] tracking-[-0.03em] leading-[120%] sm:text-[15.4px]'
                      >
                        Behance
                      </a>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='h-6 w-6 sm:w-[18px] sm:h-[18px]'>
                        <Inst />
                      </div>
                      <a
                        href='https://www.instagram.com/ophir_studio/'
                        target='_blank'
                        className='font-normal 2xl:text-[20px] text-[13px] tracking-[-0.03em] leading-[120%] sm:text-[15.4px]'
                      >
                        Instagram
                      </a>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='h-6 w-6 sm:w-[18px] sm:h-[18px]'>
                        <In />
                      </div>
                      <a
                        href='https://www.linkedin.com/company/ophir-studio/'
                        target='_blank'
                        className='font-normal 2xl:text-[20px] text-[13px] tracking-[-0.03em] leading-[120%] sm:text-[15.4px]'
                      >
                        Linkedin
                      </a>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='h-6 w-6 sm:w-[18px] sm:h-[18px]'>
                        <Facebook />
                      </div>
                      <a
                        href='https://www.facebook.com/ophirstudio'
                        target='_blank'
                        className='font-normal 2xl:text-[20px] text-[13px] tracking-[-0.03em] leading-[120%] sm:text-[15.4px]'
                      >
                        Facebook
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={cn(
                'hidden text-[#616161] font-normal text-[14px] tracking-[-0.05em] leading-[90%] flex-col gap-4',
                'sm:flex sm:text-sm sm:mt-12 sm:text-[13.47px] sm:leading-[120%] sm:tracking-[-0.03em] sm:gap-2',
                'lg:flex lg:pt-12',
                'md:flex md:text-base md:pt-14 md:flex-row md:justify-end',
                'sm:pb-20'
              )}
            >
              <Link href='/privacy'>{dict.privacy}</Link>
              <Link href='/cookie-policy'>{dict.cookie}</Link>
            </div>
            <div className='2xl:mt-32 mt-12 lg:mt-16 md:mt-16 w-full sm:mt-0 flex flex-row justify-between sm:pb-20'>
              <Image
                className='2xl:h-[176px] xl:h-[128px] lg:h-[96px] md:h-[80px] sm:h-[64px] h-[48px] w-auto'
                src={LogoFooter}
                alt=""
              />
            </div>
          </div>
          <div
            className={cn(
              'flex text-[#616161] items-center justify-between',
              'sm:hidden md:hidden'
            )}
          >
            <div className='font-normal 2xl:text-[14px] text-[9px] tracking-[-0.05em] leading-[90%]'>
              &copy; Copyright {new Date().getFullYear()}, Ophir Studio OÜ, Harju maakond, Tallinn,
              Kesklinna linnaosa, Narva mnt 7-652, 10117
            </div>
            <div className='flex gap-16 font-normal lg:hidden 2xl:text-[20px] text-[13px] tracking-[-0.03em] leading-[120%] items-center'>
              <Link href='/privacy'>{dict.privacy}</Link>
              <Link href='/cookie-policy'>{dict.cookie}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}



const style = {
  footerMailtoLink: {
    fontSize: "25px",
    color: "white"
  },
}